import { parsePhoneNumberFromString } from 'libphonenumber-js'
import * as Yup from 'yup'

import { EMPTY_STRING } from '../../../../constants/common'
import { HTML_LINK_TARGET } from '../../../../constants/html'
import { getHtmlTelLink } from '../../../../utils/link'
import { getPhoneSelectFormikFieldValidator } from '../../../Phone'

function getLink({ isPhone, isWebsite }, value) {
  if (isPhone) {
    return getHtmlTelLink(value)
  }

  return isWebsite ? value : null
}

function getLinkTarget({ isWebsite }) {
  return isWebsite ? HTML_LINK_TARGET.blank : null
}

function getInitialEditValue(typeConfig, value) {
  return typeConfig.isPhone && value.startsWith('+') ? value.slice(1) : value
}

function getFormattedValue(typeConfig, value) {
  if (!typeConfig.isPhone) {
    return value
  }

  const normalizedValue = value.startsWith('+') ? value : `+${value}`
  const parsed = parsePhoneNumberFromString(normalizedValue)

  return parsed ? parsed.formatInternational() : normalizedValue
}

function getTooltip({ t, typeConfig, value }) {
  if (typeConfig.isPhone) {
    return t('ProfileContactsWidget.TooltipPhoneKey')
  }

  if (typeConfig.isWebsite) {
    return t('ProfileContactsWidget.TooltipWebsiteKey')
  }

  return value
}

function getValidatorSchema({ t, typeConfig }) {
  if (typeConfig.isEmail) {
    return Yup.string().email(
      t('ProfileContactsWidget.ErrorEnterValidEmailKey')
    )
  }

  if (typeConfig.isWebsite) {
    return Yup.string().url(
      t('ProfileContactsWidget.ErrorEnterValidWebsiteKey')
    )
  }

  if (typeConfig.isPhone) {
    return getPhoneSelectFormikFieldValidator({
      maxError: 'ProfileContactsWidget.ErrorEnterValidPhoneKey',
      minError: 'ProfileContactsWidget.ErrorEnterValidPhoneKey',
    })
  }

  return Yup.string()
}

export function getValidator({ isCreate, t, typeConfig }) {
  const schema = getValidatorSchema({ t, typeConfig })

  return isCreate ? schema.required(true) : schema
}

export function getErrorBorderStyle(isError) {
  return isError ? { borderColor: 'var(--color-error)' } : undefined
}

export function getContactCellData({ t, typeConfig, value }) {
  if (!value) {
    return {
      infoTooltipKey: typeConfig.infoTooltipKey,
      initialEditValue: EMPTY_STRING,
      label: t(typeConfig.labelKey),
      noValueText: t(typeConfig.noValueTextKey),
    }
  }

  return {
    formattedValue: getFormattedValue(typeConfig, value),
    infoTooltipKey: typeConfig.infoTooltipKey,
    initialEditValue: getInitialEditValue(typeConfig, value),
    label: t(typeConfig.labelKey),
    link: getLink(typeConfig, value),
    target: getLinkTarget(typeConfig),
    tooltip: getTooltip({ t, typeConfig, value }),
  }
}
